import { useState } from 'react';

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { Button, Container } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { BrowserRouter, Route, Routes, Link } from "react-router-dom"
import Typescript from '@mui/material/Typography'

import Title from '../../components/Title'
import Text from '../../components/Text'

import icon_1 from '../../images/image.png'
import image from '../../images/symptoms/C_pinustaeda_iNaturalist.png'

function Project() {

  return (

    <Container className="bgwhite">

      <Grid container flexDirection="row-reverse" className="px-0">


        <Grid className="p-5" size={{ xs: 12, sm: 12, md: 9 }} >

          <Title text="project_title" variant="big" color="orange"></Title>

          <p className="paragraph">
            <Text
              text="project_1_1"
              variant="normal"
              color="black" />
            <Link to="/phyto">
              <Text
                text="project_1_2"
                variant="normal"
                color="black" />
            </Link>
            <Text
              text="project_1_3"
              variant="normal"
              color="black" />
          </p>
          <p className="paragraph">
            <Text variant="normal"
              text="project_2">
            </Text>
          </p>
          <p className="paragraph">
            <Text variant="normal"
              text="project_3">
            </Text>
          </p>
          <p className="paragraph">
            <Text variant="normal"
              text="project_4">
            </Text>
          </p>

        </Grid>


        <Grid container size={{ xs: 12, sm: 12, md: 3 }} flexDirection="column" justifyContent="space-evenly">
          <img src={image} />
         
        </Grid>

      </Grid>

    </Container>
  );
}

export default Project;
